export const OnboardingDialog: React.FC = () => {
  // Não é mais necessário, pois a organização é criada no registro
  // Mantido apenas para compatibilidade, mas não renderiza nada
  return null;
};

